import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";

const SERVICES = [
  { id: "1", icon: "🏛", name: "Architecture Design", description: "Comprehensive architectural solutions from concept to completion, blending aesthetics with functionality for residential and commercial projects." },
  { id: "2", icon: "🛋", name: "Interior Design", description: "Thoughtfully curated interiors that reflect your personality, balancing beauty, comfort, and purpose in every space." },
  { id: "3", icon: "🌿", name: "Landscape Design", description: "Creating outdoor environments that harmonise with nature and architecture, from private gardens to large-scale public spaces." },
  { id: "4", icon: "🏙", name: "Urban Planning", description: "Strategic planning for sustainable urban developments that foster community, connectivity, and long-term livability." },
  { id: "5", icon: "✏️", name: "Renovation & Remodelling", description: "Breathing new life into existing spaces with sensitive renovations that honour the original character while meeting modern needs." },
  { id: "6", icon: "📐", name: "Structural Consulting", description: "Expert structural analysis and consulting services ensuring safety, compliance, and integrity across all project types." },
  { id: "7", icon: "🔆", name: "Lighting Design", description: "Crafting ambient, task, and accent lighting strategies that enhance spatial experience and complement architectural vision." },
];

export default function Services() {
  const services = SERVICES;

  return (
    <div className="min-h-screen">
      <Navbar />
      <section
        className="pt-40 pb-16 px-6 lg:px-12"
        style={{ background: "var(--color-bg-soft)" }}
      >
        <div className="max-w-7xl mx-auto">
          <div className="text-xs tracking-widest uppercase text-gray-400 mb-3">What We Offer</div>
          <h1
            className="text-4xl md:text-5xl font-normal text-gray-900"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            Our Services
          </h1>
        </div>
      </section>

      <section className="py-20 px-6 lg:px-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map(svc => (
            <div
              key={svc.id}
              className="border border-gray-100 p-8 hover:border-gray-300 hover:shadow-sm transition-all"
            >
              <div className="text-4xl mb-5">{svc.icon}</div>
              <h2
                className="text-xl font-medium text-gray-900 mb-3"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                {svc.name}
              </h2>
              <p className="text-sm text-gray-500 leading-relaxed">{svc.description}</p>
            </div>
          ))}
        </div>
      </section>

      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
